"use client";
import { escalationSchema as l } from "./escalation-schema.js";
const f = async (o, i, n) => {
  const t = await i.chat.completions.create(
    {
      model: "inkeep-qa-expert",
      messages: o,
      tools: [
        {
          type: "function",
          function: {
            name: "provideAIAnnotations",
            description: "Provides AI confidence levels for the response",
            parameters: l
          }
        },
        {
          type: "function",
          function: {
            name: "provideRecordsConsidered",
            description: "Provides records considered in generating the response",
            parameters: {
              type: "object"
              // No need for properties as it's all defined in the backend
            }
          }
        }
      ],
      tool_choice: "auto"
    },
    n ? { headers: n } : void 0
  ), c = t.choices[0]?.message?.content;
  let s, r;
  const a = t.choices[0]?.message?.tool_calls || [];
  for (const e of a)
    e.function.name === "provideAIAnnotations" && (s = JSON.parse(e.function.arguments).aiAnnotations), e.function.name === "provideRecordsConsidered" && (r = JSON.parse(e.function.arguments).recordsConsidered ?? []);
  return {
    answer: c || null,
    aiAnnotations: s,
    recordsConsidered: r,
    messages: o
  };
};
export {
  f as generateQAModelResponse
};
